import React, { Component } from "react";
import "./BottomBanner.css";

class BottomBanner extends Component {
  render() {
    return (
      <div className="BottomBannerDiv LowPanel">
        <span className="SecondaryText">
          Developed by{" "}
          <a href="https://www.linkedin.com/in/luis-santos-09461531/" target="_blank" rel="noopener noreferrer">
            Luis Santos
          </a>
          {" "}using{" "}
          <a href="https://github.com/bgrins/TinyColor" target="_blank" rel="noopener noreferrer">
            TinyColor
          </a>
          .
        </span>
      </div>
    );
  }
}

export default BottomBanner;
